module.exports = ":host ::ng-deep .language-menu {\n  height: initial !important; }\n"